import React from 'react';
import styled from 'styled-components';

const ImageContainer = styled.div`
  width: 100%;
  height: 100%;
  background: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`;

const StyledImage = styled.img`
  ${({ $mode }) => {
    switch ($mode) {
      case 'fill':
        return `
          width: 100%;
          height: 100%;
          object-fit: cover;
        `;
      case 'center':
        return `
          max-width: 90%;
          max-height: 90%;
          object-fit: contain;
        `;
      case 'fit':
      default:
        return `
          width: 100%;
          height: 100%;
          object-fit: contain;
        `;
    }
  }}
`;

const ErrorMessage = styled.div`
  color: #ff6b6b;
  font-size: 1.5rem;
  text-align: center;
  padding: 2rem;
`;

/**
 * ImageViewer - Display images with different display modes
 *
 * @param {string} url - Image URL (can be relative or absolute)
 * @param {string} mode - Display mode: 'fit' (default), 'fill', 'center'
 * @param {string} alt - Alt text for accessibility
 */
const ImageViewer = ({
  url,
  mode = 'fit',
  alt = 'Media content'
}) => {
  // Handle relative URLs by prepending the socket/backend URL
  const socketUrl = import.meta.env.VITE_SOCKET_URL || 'http://localhost:3010';
  const resolvedUrl = url?.startsWith('/') ? `${socketUrl}${url}` : url;
  const [failed, setFailed] = React.useState(false);
  React.useEffect(() => { setFailed(false); }, [resolvedUrl]);

  if (!url) {
    return (
      <ImageContainer>
        <ErrorMessage>
          Kuva URL puuttuu
        </ErrorMessage>
      </ImageContainer>
    );
  }

  if (failed) {
    // Rendered as React children so the URL stays text — it comes from
    // screen-content config and must not be interpolated as markup (#936).
    return (
      <ImageContainer>
        <div style={{ color: '#ff6b6b', fontSize: '1.5rem', textAlign: 'center', padding: '2rem' }}>
          Kuvan lataus epäonnistui
          <br />
          <small style={{ opacity: 0.7 }}>{resolvedUrl}</small>
        </div>
      </ImageContainer>
    );
  }

  return (
    <ImageContainer>
      <StyledImage
        src={resolvedUrl}
        alt={alt}
        $mode={mode}
        onError={() => setFailed(true)}
      />
    </ImageContainer>
  );
};

export default ImageViewer;
